module.exports = __webpack_public_path__ + "static/pie_chart_2-bfb8ed682dc7cd9ff8ae841837c40887.png";